import styled from 'styled-components'
import { theme } from 'styled-tools'

export const Toolbar = styled.div`
  position: sticky;
  bottom: 0;
  background-color: ${theme('colors.white')};
`
